{
  "status": {
    "provisioning": "Aprovisionando",
    "active": "Activo",
    "suspended": "Suspendido",
    "cancelled": "Cancelado"
  },
  "checkingSession": "Verificando sesión…",
  "login": {
    "error": "No se pudo iniciar sesión.",
    "title": "Panel de la plataforma",
    "subtitle": "Acceso restringido al equipo de Xtreed.",
    "email": "Email",
    "password": "Contraseña",
    "submit": "Entrar"
  },
  "panel": {
    "errors": {
      "generic": "No se pudo completar."
    },
    "toast": {
      "created": "Área de miembros creada en {{url}}",
      "statusUpdated": "Estado actualizado."
    },
    "badge": "Plataforma",
    "logout": "Salir",
    "title": "Clientes",
    "count_one": "{{count}} área de miembros",
    "count_zero": "{{count}} áreas de miembros",
    "count_other": "{{count}} áreas de miembros",
    "newClient": "Nuevo cliente",
    "loading": "Cargando…",
    "features": "Funciones",
    "reactivate": "Reactivar",
    "suspend": "Suspender"
  },
  "form": {
    "name": "Nombre",
    "namePlaceholder": "Escuela de Juan",
    "slug": "Identificador",
    "slugPlaceholder": "escuela-de-juan",
    "adminEmail": "Email del admin",
    "adminEmailPlaceholder": "admin@escuela.com",
    "adminName": "Nombre del admin",
    "adminNamePlaceholder": "Juan García",
    "adminPassword": "Contraseña inicial",
    "submit": "Crear"
  },
  "features": {
    "community": "Comunidad",
    "certificates": "Certificados",
    "gamification": "Gamificación",
    "assistant": "Asistente de IA",
    "toast": {
      "updated": "Plan actualizado.",
      "error": "No se pudo guardar."
    },
    "loading": "Cargando funciones…",
    "includedInPlan": "Incluido en el plan",
    "enabledByClient": "· activado por el cliente",
    "disabledByClient": "· desactivado por el cliente"
  }
}
